import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Lightbox from './Lightbox';

function getThumbUrl(url, width = 600) {
  if (!url || typeof url !== 'string') return url;
  if (url.includes('/cdn-cgi/image/')) return url;
  if (url.startsWith('https://assets.auxodev.dk/')) {
    return url.replace('https://assets.auxodev.dk/', `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=80,format=auto/`);
  }
  return url;
}

const MATERIALER_IMAGES = [
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-9995.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-9976.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-9903.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-9894.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-9883.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-9824.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-9804.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-9803.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-9797.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-9795.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7656.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7645.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7640.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7594.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7447.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7445.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7418.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7410.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7405.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7396.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7373.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7357.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7352.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7341.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7300.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7285.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7261.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7212.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7208.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7188.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7179.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7164.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7125.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7084.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7054.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7025.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-6974.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-6876.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-6802.jpg",
  "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-6754.jpg"
];

export default function StemningSection({ videoer = [], gallerier = [] }) {
  const [selectedVideo, setSelectedVideo] = useState(videoer[0] || null);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  // Galleribilleder fra CMS eller det omfattende udvalg fra materialer
  const stemningImages = (gallerier[0]?.billeder && gallerier[0].billeder.length > 0)
    ? gallerier[0].billeder
    : MATERIALER_IMAGES;

  function openLightbox(idx) {
    setLightboxIndex(idx);
    setLightboxOpen(true);
  }

  const activeVideoUrl = selectedVideo?.video_url || "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/oerbike-2025.mp4";

  return (
    <section className="py-20 bg-[#090a0f] border-t border-b border-pink-500/20 relative overflow-hidden">
      {/* Baggrunds-neon glød */}
      <div className="absolute top-1/2 left-0 -translate-y-1/2 w-96 h-96 bg-pink-600/10 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-600/10 rounded-full blur-3xl pointer-events-none"></div>

      <div className="max-w-[1520px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-pink-500/20 text-pink-400 border border-pink-500/30 mb-3">
            Lys, Musik, Fællesskab & Energi
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-white font-display uppercase tracking-tight">
            Oplev stemningen fra ØrBike
          </h2>
          <p className="text-slate-300 text-sm sm:text-base mt-3 leading-relaxed">
            Se hvordan over 230 cykler, 1.000 engagerede deltagere og Danmarks mest energiske instruktører forvandler Ørbæk Midtpunkt til én stor kærlig cykelfest for livet.
          </p>
        </div>

        {/* Feature Video sektion med videoens første billede som placeholder */}
        <div className="bg-[#12141e] border border-pink-500/30 rounded-2xl sm:rounded-3xl p-3 sm:p-6 shadow-[0_0_35px_rgba(255,42,141,0.2)] mb-14">
          <div className="relative rounded-xl sm:rounded-2xl overflow-hidden bg-black aspect-video">
            <video
              key={activeVideoUrl}
              controls
              playsInline
              preload="metadata"
              poster="https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-7352.jpg"
              className="w-full h-full object-cover"
            >
              <source src={`${activeVideoUrl}#t=0.001`} type="video/mp4" />
              Din browser understøtter desværre ikke HTML5 video.
            </video>
          </div>

          {/* Video selector knapper hvis der er flere */}
          {videoer.length > 1 && (
            <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-3">
              {videoer.map((vid, idx) => {
                const isSelected = selectedVideo?.id === vid.id || (selectedVideo == null && idx === 0);
                return (
                  <button
                    key={vid.id || idx}
                    type="button"
                    onClick={() => setSelectedVideo(vid)}
                    className={`flex items-center gap-3 p-3 rounded-xl border text-left transition-all ${
                      isSelected
                        ? "bg-pink-500/20 border-pink-500 text-white shadow-[0_0_15px_rgba(255,42,141,0.3)]"
                        : "bg-slate-900/60 border-slate-800 text-slate-300 hover:border-slate-700 hover:text-white"
                    }`}
                  >
                    <div className="w-8 h-8 rounded-lg bg-pink-500/30 text-pink-400 flex items-center justify-center shrink-0">
                      <i className="fa-solid fa-play text-xs" aria-hidden="true"></i>
                    </div>
                    <div className="overflow-hidden">
                      <div className="font-bold text-xs truncate">{vid.titel}</div>
                      <div className="text-[11px] text-slate-400 truncate">{vid.beskrivelse || "Se video"}</div>
                    </div>
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* Stemningsgalleri – Fuld skærmbredde med ægte Masonry layout */}
      <div className="w-full px-2 sm:px-4 lg:px-6 pt-24 mb-12 relative z-10">
        <div className="columns-2 sm:columns-3 md:columns-4 lg:columns-5 xl:columns-6 gap-3 sm:gap-4 space-y-3 sm:space-y-4">
          {stemningImages.map((imgUrl, index) => (
            <div
              key={index}
              onClick={() => openLightbox(index)}
              className="break-inside-avoid group relative overflow-hidden rounded-xl sm:rounded-2xl cursor-pointer border border-pink-500/20 hover:border-pink-500/80 transition-all duration-300 hover:scale-[1.02] shadow-lg bg-slate-900/60"
            >
              <img
                src={getThumbUrl(imgUrl, 600)}
                alt={`ØrBike stemning ${index + 1}`}
                loading="lazy"
                className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105 block"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-between p-3">
                <span className="text-[11px] font-semibold text-white uppercase tracking-wider flex items-center gap-1.5">
                  <i className="fa-solid fa-expand text-pink-400" aria-hidden="true"></i>
                  <span>Forstør</span>
                </span>
                <span className="w-7 h-7 rounded-full bg-pink-500 text-white flex items-center justify-center text-xs shadow-md">
                  <i className="fa-solid fa-camera" aria-hidden="true"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-[1520px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
        {/* CTA til det komplette fotoarkiv */}
        <Link
          to="/fotoarkiv"
          className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-slate-900 border border-pink-500/40 text-pink-400 hover:text-white hover:bg-pink-600 hover:border-pink-600 font-bold text-xs uppercase tracking-wider transition-all duration-300 shadow-[0_0_20px_rgba(255,42,141,0.2)]"
        >
          <i className="fa-solid fa-images" aria-hidden="true"></i>
          <span>Se hele fotoarkivet fra ØrBike</span>
        </Link>
      </div>

      {/* Lightbox */}
      <Lightbox
        images={stemningImages}
        currentIndex={lightboxIndex}
        isOpen={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
        onPrev={() => setLightboxIndex((prev) => (prev > 0 ? prev - 1 : stemningImages.length - 1))}
        onNext={() => setLightboxIndex((prev) => (prev < stemningImages.length - 1 ? prev + 1 : 0))}
      />
    </section>
  );
}
